import React from "react";

const PAgeTitle = () => {
  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-lg border border-white border-opacity-30 shadow-lg text-center p-3 rounded-3xl mx-4 mt-4 font-bold underline">
      Master Setup IPD
    </div>
  );
};

export default PAgeTitle;
